import React, {useCallback, useMemo, useState} from 'react'
import styled from 'styled-components'
import {VideoFilePlayer} from 'common/components'
import {GiftShopProfileResendVideoItemHiResProps} from './GiftShopProfileResendVideoProps'
import GiftShopProfileResendVideoItemBase from './GiftShopProfileResendVideoItemBase'

const StyledVideo = styled(VideoFilePlayer)`
  object-fit: contain;
  width: 100%;
  aspect-ratio: 1;
`

export default function GiftShopProfileResendVideoItemHiRes({
  videoRef,
  onVideoLoaded,
  resendData,
  resendFile,
}: GiftShopProfileResendVideoItemHiResProps) {
  const statePaused = useState(true)
  const setPaused = statePaused[1]
  const date = useMemo(
    () =>
      resendData && new Date(resendData.image.file.lastModified).toISOString(),
    [resendData],
  )

  const handlePause = useCallback(() => {
    setPaused(true)
    videoRef.current?.pause()
  }, [setPaused, videoRef])

  const handlePlay = useCallback(() => {
    setPaused(false)
    videoRef.current?.play()
  }, [setPaused, videoRef])

  const handleRenderVideoPlayer = useMemo(
    () =>
      resendFile && (
        <StyledVideo
          videoRef={videoRef}
          videoFile={resendFile}
          onEnded={handlePause}
          onLoadStart={() => {
            handlePause()
          }}
          onVideoLoaded={onVideoLoaded}
        />
      ),
    [handlePause, onVideoLoaded, resendFile, videoRef],
  )

  return (
    <GiftShopProfileResendVideoItemBase
      statePaused={statePaused}
      videoElement={handleRenderVideoPlayer}
      date={date}
      duration={resendData?.image.duration}
      size={resendData?.image.file.size}
      title={resendData?.image.file.name}
      isNewContent
      hasSource={!!resendData?.image.src}
      onPlay={handlePlay}
      onPause={handlePause}
    />
  )
}
